import styled from '@emotion/styled';
import { Colors, helperButtonReset } from '@utex/ui-kit';

export const SelectButton = styled('button')`
  ${helperButtonReset};
  display: flex;
  align-items: center;
  padding: 0.8rem 1.6rem;
  width: 100%;
  text-align: left;
  border-radius: 0.8rem;
  background-color: ${Colors.ut.inputRegular};

  &:focus {
    background-color: ${Colors.ut.inputDown};
  }
`;

export const Icon = styled('img')`
  flex-shrink: 0;
  width: 2.4rem;
  height: 2.4rem;
  margin-right: 0.6rem;
`;

export const SubIcon = styled('img')`
  flex-shrink: 0;
  margin-right: 0.6rem;
`;
